import { Component, OnInit, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef, MatChipInputEvent } from "@angular/material";
import * as _ from "lodash";
import { fuseAnimations } from "../../../../../../../../../../core/animations";

/** Local file */
import { toastMsg, displayValues } from "../../../../../../../utils/index";
import { ToastComponent } from "../../../../../../../common/toast.component";

// services
import { SideNavService } from "../../../../sidenav.service";

// Models
import { UpdateSolutionDescription, SolutionDescriptionInitialDM, SolutionDescriptionNodes } from "../../../../../../../models";
import { AuditHistoryService } from "../../../../../../../../../../core/services/audit-history.service";

/** Local component */

@Component({
  selector: "spekwo-edit-solution",
  templateUrl: "./edit-solution.component.html",
  styleUrls: ["./edit-solution.component.scss"],
  animations: fuseAnimations
})
export class EditSolutionComponent implements OnInit {

  solutionValues: any;
  formValues: SolutionDescriptionNodes;
  isLoading: boolean = false;
  toastMsg = toastMsg;
  displayValues = displayValues;

  constructor(
    /** Local component */
    public toastComponent: ToastComponent,
    private _sideNavService: SideNavService,
    public dialogRef: MatDialogRef<EditSolutionComponent>,
    private _toastComponent: ToastComponent,
    @Inject(MAT_DIALOG_DATA) private data: any,
    public auditHistoryService: AuditHistoryService,
  ) {
    this.solutionValues = data.solution;
  }

  ngOnInit() { }

  //Update funcitonality
  updateContact(submitedValues) {

    this.isLoading = true;
    this.formValues = submitedValues.SolutionDescriptionInitialDM;
    this.formValues.keyword = [];
    //Pushing keywords fields to keyword array
    this.formValues.keyword.push(submitedValues.key1);
    this.formValues.keyword.push(submitedValues.key2);
    this.formValues.keyword.push(submitedValues.key3);
    this.formValues.keyword.push(submitedValues.key4);

    // Calling service updateSolutionDescriptionByIdOnDb function
    this._sideNavService
      .updateSolutionDescriptionByIdOnDb(this.formValues)
      .then(async (createRes: UpdateSolutionDescription) => {
        this.isLoading = false;
        this.dialogRef.close([this.formValues, 'success']);
        // this._sideNavService.onSolutionInfo.next(true);
        this.auditHistoryFunCall(displayValues.success);

        this._toastComponent.showToast(this.toastMsg.updateSuccess);
      })
      .catch(err => {
        this.isLoading = false;
        this.auditHistoryFunCall(displayValues.failed);
      });
  }

  auditHistoryFunCall(status) {
    let oldparams = {
      "solution": this.data && this.data.solution && this.data.solution.solution ? this.data.solution.solution : null,
      "keyPrimCategory": this.data && this.data.solution && this.data.solution.keyPrimCategory ? this.data.solution.keyPrimCategory : null,
      "subcategory": this.data && this.data.solution && this.data.solution.subcategory ? this.data.solution.subcategory : null,
      "key1": this.data && this.data.solution && this.data.solution.key1 ? this.data.solution.key1 : null,
      "key2": this.data && this.data.solution && this.data.solution.key2 ? this.data.solution.key2 : null,
      "key3": this.data && this.data.solution && this.data.solution.key3 ? this.data.solution.key3 : null,
      "key4": this.data && this.data.solution && this.data.solution.key4 ? this.data.solution.key4 : null,
      "costOption": this.data && this.data.solution && this.data.solution.costOption ? this.data.solution.costOption : null,
      "totalCost": this.data && this.data.solution && this.data.solution.totalCost ? this.data.solution.totalCost : null,
    };

    let newParams = {
      "solution": this.formValues && this.formValues.solution ? this.formValues.solution : null,
      "keyPrimCategory": this.formValues && this.formValues.keyPrimCategory ? this.formValues.keyPrimCategory : null,
      "subcategory": this.formValues && this.formValues.subcategory ? this.formValues.subcategory : null,
      "key1": this.formValues && this.formValues.key1 ? this.formValues.key1 : null,
      "key2": this.formValues && this.formValues.key2 ? this.formValues.key2 : null,
      "key3": this.formValues && this.formValues.key3 ? this.formValues.key3 : null,
      "key4": this.formValues && this.formValues.key4 ? this.formValues.key4 : null,
      "costOption": this.formValues && this.formValues.costOption ? this.formValues.costOption : null,
      "totalCost": this.formValues && this.formValues.totalCost ? this.formValues.totalCost : null,
    };


    let auditLogPayload = {
      roleId: window.localStorage.getItem('roleId'),
      userId: window.localStorage.getItem('userUID'),
      orderId: null,
      newData: newParams,
      oldData: oldparams,
      auditType: "update_se_into_db",
      logsDesc: "Solution was updated to the database ",
      platform: "Executive Dashboard",
      status: status,
      createdAt: "now()"
    };
    this.auditHistoryService.auditHistoryCall(auditLogPayload);
  }


}




// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/operations/solution-description/edit-solution-description/edit-solution.component.ts